import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Stack,
  Typography,
  Tooltip,
  Link,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import { Result } from '../../pages/rules/modules/resultEnum';
import { ErrorIcon, NotRunIcon, SuccessIcon, WarningIcon } from '../components/Icon';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface EvaluatedRuleProps {
  id: number;
  name: string;
  desc: string;
  message: string;
  result: Result;
}

export const GetIcon = ({
  result,
  heightIcon,
  widthIcon
}: {
  result: Result;
  heightIcon: string;
  widthIcon: string;
}) => {
  const usePalette = useTheme().palette;

  const resultIcon = () => {
    switch (result) {
      case Result.SUCCESS:
        return (
          <SuccessIcon
            style={{ stroke: usePalette.success.main, height: heightIcon, width: widthIcon }}
          />
        );
      case Result.WARNING:
        return (
          <WarningIcon
            style={{ stroke: usePalette.warning.main, height: heightIcon, width: widthIcon }}
          />
        );
      case Result.ERROR:
        return (
          <ErrorIcon
            style={{ stroke: usePalette.error.main, height: heightIcon, width: widthIcon }}
          />
        );
      case Result.NOT_RUN:
        return (
          <NotRunIcon
            style={{ stroke: usePalette.primary.dark, height: heightIcon, width: widthIcon }}
          />
        );
    }
  };
  return <>{resultIcon()}</>;
};

export const EvaluatedRule = (props: EvaluatedRuleProps) => {
  const { id, name, desc, message, result } = props;
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const usePalette = theme.palette;

  return (
    <Accordion
      elevation={1}
      sx={{
        borderBottom: 1,
        borderRadius: 1,
        borderBottomColor: usePalette.background.paper,
        backgroundColor: open ? usePalette.success.light : usePalette.background.paper
      }}
      disableGutters={true}>
      <Tooltip title={desc} placement="top">
        <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={() => setOpen(!open)}>
          <GetIcon result={result} heightIcon={'16px'} widthIcon={'16px'} />
          <RouterLink to={`/rules/${id}`} style={{ textDecoration: 'none' }}>
            <Link underline="hover">
              <Typography
                variant={'body2'}
                marginLeft="5px"
                fontWeight={theme.typography.fontWeightBold}>
                {name}
              </Typography>
            </Link>
          </RouterLink>
        </AccordionSummary>
      </Tooltip>
      <AccordionDetails>
        <Stack
          direction={'column'}
          justifyContent={'space-between'}
          alignItems={'left'}
          padding={1}
          spacing={1}
          paddingTop={0}>
          <Typography variant="body2">{desc}</Typography>
          <Typography variant="body2">{message}</Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
